import React from 'react';
import { colors } from './theme';

// Visible focus rings for keyboard users + prefers-reduced-motion override.
// Scoped to .shona-page so we don't leak styles into other routes.
//
// `select` and `[role="slider"]` matter as much as button/input here: the
// voice picker is a native select, and AudioPlayBar's scrub track is a
// tabbable, arrow-key-operable role="slider" that would otherwise have no
// visible focus state at all.
const A11yStyles = () => (
  <style>{`
    .shona-page button:focus-visible,
    .shona-page a:focus-visible,
    .shona-page textarea:focus-visible,
    .shona-page input:focus-visible,
    .shona-page select:focus-visible,
    .shona-page [role='slider']:focus-visible {
      outline: 2px solid ${colors.accent};
      outline-offset: 2px;
    }

    /* Shared by NowPlayingBar and the per-card now-playing dots. Defined here
       because A11yStyles is the one element every shona-tts page renders. */
    @keyframes shona-nowplaying-pulse {
      0%, 100% { transform: scale(0.7); opacity: 0.5; }
      50% { transform: scale(1.15); opacity: 1; }
    }

    /* touch feedback: kill the grey tap flash, add a press response */
    .shona-page button {
      -webkit-tap-highlight-color: transparent;
      touch-action: manipulation;
    }
    .shona-page button:not(:disabled):active {
      transform: scale(0.97);
    }

    /* Navbar email: truncate rather than push Sign out off the row. */
    .shona-page .shona-nav-email {
      max-width: 320px;
    }
    @media (max-width: 560px) {
      .shona-page .shona-nav-email {
        max-width: 150px;
      }
    }
    /* Below this the address is too clipped to be worth the space — the
       Sign out button already communicates the signed-in state, and the full
       address stays available via the element's title attribute. */
    @media (max-width: 380px) {
      .shona-page .shona-nav-email {
        display: none;
      }
    }

    @media (max-width: 640px) {
      /* primary-action hierarchy + sticky reach on mobile */
      .shona-page .reader-actions {
        flex-wrap: wrap;
      }
      .shona-page .reader-action-group {
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        row-gap: 12px;
      }
      .shona-page .reader-generate {
        flex: 1 1 100%;
        order: 2;
        position: sticky;
        bottom: calc(12px + env(safe-area-inset-bottom));
        z-index: 5;
        padding: 16px 22px;
        font-size: 17px;
        box-shadow: ${colors.shadow};
      }
      /* clear the fixed now-playing bar when one is on screen */
      .shona-page.has-nowplaying .reader-generate {
        bottom: calc(84px + env(safe-area-inset-bottom));
      }
    }
    @media (prefers-reduced-motion: reduce) {
      .shona-page *,
      .shona-page *::before,
      .shona-page *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
        scroll-behavior: auto !important;
      }
    }
  `}</style>
);

export default A11yStyles;
